import { renderOverlay } from "./ui/overlay";
import { bindCursor } from "./ui/interactions";
import { MatrixGlitch } from "./ui/matrixGlitch";
import { RandomTextReveal } from "./ui/textReveal";
import "./styles/main.css";
import "./styles/avatar.css";

async function init() {
  const video = document.getElementById("video-bg") as HTMLVideoElement;
  const whiteOverlay = document.querySelector(".white-overlay") as HTMLElement;
  const body = document.body;

  // Wait for both DOM and styles to be fully loaded
  await new Promise<void>((resolve) => {
    if (document.readyState === "complete") {
      resolve();
    } else {
      window.addEventListener("load", () => resolve(), { once: true });
    }
  });

  // Add a small delay to ensure all styles are painted
  await new Promise((resolve) => setTimeout(resolve, 100));

  // Wait for video to be ready
  const videoReady = new Promise<void>((resolve) => {
    if (!video) {
      resolve();
      return;
    }

    // Check if video has enough data loaded
    if (video.readyState >= 3) {
      // HAVE_FUTURE_DATA or better
      resolve();
    } else {
      video.addEventListener("canplay", () => resolve(), { once: true });
    }

    // Fallback timeout in case video doesn't load
    setTimeout(() => resolve(), 3000);
  });

  // Wait for video to be ready
  await videoReady;

  // Start video playback first
  if (video) {
    video.play().catch(() => {
      // Autoplay blocked, will play on first user interaction
      document.addEventListener("click", () => video.play(), { once: true });
    });
  }

  // Immediately fade out white overlay as video starts
  if (whiteOverlay) {
    whiteOverlay.classList.add("fade-out");
  }

  // Fade in UI elements (starts after white overlay is fading)
  setTimeout(() => {
    body.classList.remove("loading");
  }, 500);

  // Initialize Matrix glitch effect (will fade in with its transition)
  new MatrixGlitch("matrix-glitch");

  // Render DOM overlay with CV content (will fade in with its transition)
  renderOverlay();

  // Animate text reveals after everything is visible
  new RandomTextReveal(".hero-title", 1800, 100); // Start after UI fades in
  new RandomTextReveal(".hero-subtitle", 1800, 1);

  // Bind AI cursor (will fade in with its transition)
  bindCursor();
}

init();
